import React from 'react';
import { Card, Row } from 'react-bootstrap';
import { Testo, Tendina, Elenco, ElencoLibero } from './campi';
import { gruppiSanguigni, opzioniElenchi } from './modificaAnagrafica';
import DatiSanPlayer from '../../Clienti/datiSanitari_player';

/*
 * Tab dei dati sanitari in modifica (player e junior). I certificati medici restano in sola lettura, sopra il box
 * (stessa tabella della vista: DatiSanPlayer con `soloCertificati`).
 * I valori medi non si possono togliere (il server non accetta un valore vuoto), solo cambiare.
 * Props: tipo, modifica (useModificaAnagrafica).
 */
const DatiSanitariModifica = ({ tipo, modifica }) => {
    const { f, imposta, profiloPrivato } = modifica;
    const senior = tipo !== 'junior';
    const campo = (chiave) => ({ id: chiave, valore: f[chiave], onChange: (v) => imposta(chiave, v) });
    const elenco = (chiave) => ({ id: chiave, valori: f[chiave], onChange: (v) => imposta(chiave, v) });
    const intero = { tipo: 'number', min: 0, step: 1, inputMode: 'numeric' };

    return (
        <>
            {profiloPrivato && <DatiSanPlayer privateProfile={profiloPrivato} soloCertificati />}
            <Card>
                <Card.Body className="sid-card-body--spaced">
                    <h5 className="sid-form-section">Valori medi</h5>
                    <Row className="g-4">
                        <Tendina {...campo('bloodType')} etichetta="Gruppo sanguigno" opzioni={gruppiSanguigni} />
                        <Testo {...campo('averageHeartRate')} {...intero} etichetta="Battito cardiaco medio (bpm)" />
                        <Testo {...campo('averageLowBloodPressure')} {...intero} etichetta="Pressione minima media (mmHg)" />
                        <Testo {...campo('averageHighBloodPressure')} {...intero} etichetta="Pressione massima media (mmHg)" />
                    </Row>

                    <h5 className="sid-form-section">Alimentazione</h5>
                    <Row className="g-4">
                        <Elenco {...elenco('foodAllergies')} etichetta="Allergie alimentari" opzioni={opzioniElenchi.foodAllergies} />
                        <Elenco {...elenco('foodIntollerances')} etichetta="Intolleranze alimentari" opzioni={opzioniElenchi.foodIntollerances} />
                    </Row>

                    <h5 className="sid-form-section">Storia clinica</h5>
                    <Row className="g-4">
                        <Elenco {...elenco('traumas')} etichetta="Traumi" opzioni={opzioniElenchi.traumas} />
                        {senior && <Elenco {...elenco('medicalOperations')} etichetta="Interventi medici" opzioni={opzioniElenchi.medicalOperations} />}
                        <ElencoLibero {...elenco('medicines')} etichetta="Farmaci" />
                        {senior && <ElencoLibero {...elenco('hereditaryDiseases')} etichetta="Malattie ereditarie" />}
                    </Row>
                </Card.Body>
            </Card>
        </>
    );
};

export default DatiSanitariModifica;
